import { createAsyncThunk, current } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateDeleteChat = {
  deleteChat: { data: null, loading: false, error: null },
};

export const deleteChat = createAsyncThunk('user/deleteChat', async (chatId, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .delete(`${process.env.REACT_APP_SERVER_API}/chat/chats/${chatId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
    })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response);
    });
});

export const reducerDeleteChat = {
  [deleteChat.pending]: (state) => {
    // state.deleteChat.data = null;
    state.deleteChat.loading = true;
    state.deleteChat.error = null;
  },
  [deleteChat.fulfilled]: (state, action) => {
    state.deleteChat.loading = false;
    state.deleteChat.data = true;
    state.deleteChat.error = null;
  },
  [deleteChat.rejected]: (state, action) => {
    state.deleteChat.loading = false;
    state.deleteChat.error = action;
  },
};
